import * as Immutable from 'immutable';
import {
  GET_PLAN_HOLDINGS_ABORTED,
  GET_PLAN_HOLDINGS_REQUESTED,
  GET_PLAN_HOLDINGS_COMPLETED,
  GET_PLAN_HOLDINGS_FAILED,
  // RESET_PLAN_HOLDINGS_REQUESTED,
  // RESET_PLAN_HOLDINGS_COMPLETED,
} from '../../actions/planholdings/types';

const schema = {
  // status: 'INIT', // INIT/OK/ERROR
  error: null,
  data: { items: [] },
  resettingdata: false,
  gettingdata: false,
  gotdata: false,
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PLAN_HOLDINGS_ABORTED:
      return state.set('error', null).set('gettingdata', false);

    case GET_PLAN_HOLDINGS_REQUESTED:
      return state.set('error', null).set('gettingdata', true);

    case GET_PLAN_HOLDINGS_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('data', action.payload);

    case GET_PLAN_HOLDINGS_FAILED:
      return state.set('error', action.payload);

    default:
      return state;
  }
};

export { initialState };

export default reducer;
